export default "__VITE_ASSET__IvabUfcr__"